// extracted by mini-css-extract-plugin
export default {"objectiveCard":"ObjectiveCard_objectiveCard__k+WMX"};